import { jsx as _jsx } from "react/jsx-runtime";
// text-box-trim is spec-restricted to the inline element directly wrapping
// the text — it silently no-ops on the flex containers every control uses.
// This primitive enforces that constraint at every callsite. Chrome 133+,
// Safari 18.2+; Firefox falls back to line-height: 1 (today's behavior
// across every comparable shipped DS).
const TRIM_STYLE = {
    display: 'inline-block',
    lineHeight: 1,
    textBox: 'trim-both cap alphabetic',
};
export function TextTrim({ children, style, }) {
    return _jsx("span", { style: style ? { ...TRIM_STYLE, ...style } : TRIM_STYLE, children: children });
}
//# sourceMappingURL=text-trim.js.map